
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/medicine/otc-medicine",
      function () {
        return require("private-next-pages/app/medicine/otc-medicine/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/medicine/otc-medicine"])
      });
    }
  